import React, { useState, useEffect } from 'react';
import Sidebar from '../sidebar';
import CommunityManageNav from '../community_manage_nav';
import MemberHeader from './member_header';
import MemberList from './member_list';
import Invite from './invite';
import Modal from '../modal';
import { flashForReact } from '../../flash_react';
import { memberSearch, getSearchParams, defaultHeaders } from '../../ajax_utils';

const MemberSection = ({ allMembers, initCommunity, initCompanies, initLocations, pendingCount, blankHeadshot, admin }) => {
  const sidebarOptions = [
    'active',
    'pending',
    'invited',
    'removed',
    'declined',
    'admins'
  ];
  const initTab = getSearchParams(sidebarOptions);
  const [tabMembers, setTabMembers] = useState([]);
  const [community, setCommunity] = useState(initCommunity);
  const [tab, setTab] = useState(initTab);
  const [toggleInviteTab, setToggleInviteTab] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [member, setMember] = useState({});
  const [memberRole, setMemberRole] = useState('');
  const [updatedMember, setUpdatedMember] = useState({});
  const [page, setPage] = useState(0);
  const [companies, setCompanies] = useState(initCompanies);
  const [locations, setLocations] = useState(initLocations);
  const [searchText, setSearchText] = useState('');
  const [searchCompany, setSearchCompany] = useState('');
  const [searchLocation, setSearchLocation] = useState('');
  const [resetSearchOnTabChange, setResetSearchOnTabChange] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setPage(0);
    let members;
    memberSearch({ text: '', company: '', city: '', tab: tab, page: 0 },
    (res) => {
      members = res.members;
      setTabMembers(members);
      setCompanies(res.companies);
      setLocations(res.locations);
      setIsLoading(false);
    },
    (res) => console.log(res));
  }, [updatedMember, tab]);

  useEffect(() => {
    setCommunity(community);
  }, [community]);

  useEffect(() => {
    setMemberRole(member.role);
  }, [member]);

  const loadMoreMembers = (event) => {
    const target = event.target;
    if (target.scrollHeight - target.scrollTop === target.clientHeight) {
      setPage(page + 1);
      memberSearch({ text: searchText, company: searchCompany, city: searchLocation, tab: tab, page: page + 1 },
      (res) => {
        setTabMembers([...tabMembers, ...res.members]);
      },
      (res) => console.log(res));
    }
  };

  const searchSuccess = (res) => {
    setTabMembers(res.members);
    setIsLoading(false);
  };

  const searchError = (res) => {
    flashForReact('notice', res.message);
    setIsLoading(false);
  };

  const handleSearch = () => {
    setIsLoading(true);
    setPage(0);
    return memberSearch({ text: searchText, company: searchCompany, city: searchLocation, tab, page: 0 }, (res) => searchSuccess(res), (res) => searchError(res));
  };

  const resetTabMembers = () => {
    let members;
    memberSearch({ text: '', company: '', city: '', tab },
    (res) => {
      members = res.members;
      setTabMembers(members);
      setIsLoading(false);
    },
    (res) => console.log(res));
  };

  const handleContentChange = () => {
    return toggleInviteTab ? (
      <Invite
        community={community}
        setToggleInviteTab={setToggleInviteTab}
        setTab={setTab}
      />
    ) : (
      <>
        <MemberHeader
          community={community}
          allMembers={allMembers}
          locations={locations}
          companies={companies}
          tab={tab}
          tabMembers={tabMembers}
          setToggleInviteTab={setToggleInviteTab}
          resetTabMembers={resetTabMembers}
          setTabMembers={setTabMembers}
          handleSearch={handleSearch}
          searchText={searchText}
          setSearchText={setSearchText}
          searchCompany={searchCompany}
          setSearchCompany={setSearchCompany}
          searchLocation={searchLocation}
          setSearchLocation={setSearchLocation}
          setResetSearchOnTabChange={setResetSearchOnTabChange}
          resetSearchOnTabChange={resetSearchOnTabChange}
        />
        {isLoading ? (
          <div className="d-flex justify-content-center">
            <span className="spinner-border spinner-border-sm me-1 mt-1" role="status" aria-hidden="true"></span>
            <p className='h5 text-center'>Loading...</p>
          </div>
        ) : (
          <div onScroll={loadMoreMembers}>
            <MemberList
              members={tabMembers}
              tab={tab}
              setMember={setMember}
              handleModalOpen={handleModalOpen}
              communityId={community.id}
              setUpdatedMember={setUpdatedMember}
              blankHeadshot={blankHeadshot}
              admin={admin}
            />
          </div>
        )}
      </>
    );
  };

  const handleModalOpen = (member) => {
    setMember(member);
    setMemberRole(member.role);
  };

  const handleRoleUpdate = (e) => {
    e.preventDefault();
    $.ajax({
      beforeSend: (xhr) => defaultHeaders(xhr),
      url: `${location.pathname}/${community.id}`,
      method: 'PATCH',
      data: {
        member: {
          member_id: member.id,
          community_id: community.id,
          role: memberRole
        }
      }
    }).success((res) => {
      setUpdatedMember(res.member);
      flashForReact('notice', res.message);
    }).error((res) => {
      flashForReact('danger', res.message);
    });
  };

  const handleSubscriptionDelete = (e) => {
    e.preventDefault();
    $.ajax({
      beforeSend: (xhr) => defaultHeaders(xhr),
      url: `${location.pathname}/${community.id}`,
      method: 'DELETE',
      data: { member: { member_id: member.id, community_id: community.id } }
    }).done((res) => {
      setUpdatedMember(res.member);
      if (res.success) {
        flashForReact('notice', res.message);
      } else {
        flashForReact('danger', res.message);
      }
    });
  };

  const handleRestartSubscription = (e) => {
    e.preventDefault();
    $.ajax({
      beforeSend: (xhr) => defaultHeaders(xhr),
      url: `${location.pathname}/restart-subscription`,
      method: 'POST',
      data: { member: { member_id: member.id, community_id: community.id } }
    }).success((res) => {
      setUpdatedMember(res.member);
      flashForReact('notice', res.message);
    }).error((res) => {
      flashForReact('danger', res.message);
    });
  };

  return (
    <div className='communities v2'>
      <CommunityManageNav name={community.name} />
      <section className='mt-6 mt-md-8 members'>
        <div className='container-xxl'>
          <div className='row justify-content-between'>
            <Sidebar
              options={sidebarOptions}
              setTab={setTab}
              tab={tab}
              closeInviteTab={setToggleInviteTab}
              resetSearchInput={setResetSearchOnTabChange}
              pendingCount={pendingCount}
            />
            <div className='col-md-2 col-lg-3 sidebar-placeholder'></div>
            <main className='col-12 col-md-8 col-lg-9 mt-4 mt-md-0 ps-lg-6'>
              {handleContentChange()}
            </main>
          </div>
        </div>
      </section>
      {
        admin &&
        <Modal
          member={member}
          memberRole={memberRole}
          setMemberRole={setMemberRole}
          modalId={'changeRoleModal'}
          label={'Update role'}
          title={'Change role'}
          subtitle={'role'}
          handleClick={(e) => handleRoleUpdate(e)}
        />
      }

      <Modal
        member={member}
        modalId={'restartSubscriptionModal'}
        label={'Confirm'}
        title={'Are you sure you want to restart this subscription'}
        handleClick={(e) => handleRestartSubscription(e)}
      />
      <Modal
        member={member}
        modalId={'removeMemberModal'}
        label={'Confirm'}
        title={'Are you sure you want to remove this user?'}
        handleClick={(e) => handleSubscriptionDelete(e)}
      />
      <Modal
        member={member}
        modalId={'applicationModal'}
        label={'Close'}
        title={'Application details'}
      />
    </div>
  );
};

export default MemberSection;
